export default {
	"789f13cf1e5dab1fa6c88de8159ba153": "保存中...",
	"35aba4c95d788d27d205c85664d661ec": "保存圖片至相冊"
}
